var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPincode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm107-194h42v-252h-32l-73 49 21 33 42-28v198Zm133 0h163v-38H434v-2q14-12 30.5-26.5T494-448q21-20 33-38.5t12-44.5q0-32-22-53.5T460-606q-30 0-50.5 14T379-555l38 18q5-11 17-19t26-8q18 0 28 10t10 24q0 20-10 33.5T461-468q-23 21-40.5 37T380-393v39Zm314 0q36 0 59.5-17.5T777-426q0-25-13-41t-34-18v-1q19-6 28.5-19.5T768-541q0-30-21.5-47.5T693-606q-22 0-42 12t-33 35l34 18q8-11 18.5-17.5T693-565q15 0 24.5 8.5T727-533q0 17-11.5 23t-30.5 6h-14v39h15q19 0 34.5 10t15.5 29q0 18-11.5 27.5T694-389q-15 0-29-10t-20-27l-35 13q8 27 28.5 43t55.5 16ZM140-220h680v-520H140v520Zm0 0v-520 520Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincode);
export default __webpack_public_path__ + "static/media/pincode.f2416d24eefd7ef529d4b6a0afe80485.svg";
export { ForwardRef as ReactComponent };